import { compose } from 'recompose';
import RscoreAuditReport from './RscoreAuditReport';
import withRequestTracker from '../../../utils/composition/withRequestTracker';
import {
  query, DOWNLOAD_REPORT, mutation
} from './API';

const ComposedProductivity = compose(
  DOWNLOAD_REPORT,
  withRequestTracker({
    query,
    mutation,
  }),
)(RscoreAuditReport);

export default ComposedProductivity;
